import React, { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import UserInfo from "../../components/userinfo"
import { useUser } from '../../contexts/UserContext'
import { showToast } from '../../utils/messageUtil'
import './index.css'

const CLOSED_TIP = '澳多管车预约入口已关闭，请到轻维管车系统进行预约'

export default function Home() {
    const navigate = useNavigate()
    const location = useLocation()
    const { userInfo, isAdmin, isDriver, loading, refreshUserInfo } = useUser()
    const [hasRefreshed, setHasRefreshed] = useState(false)

    // 检查用户信息是否完整
    const isUserInfoComplete = () => {
        if (!userInfo) return false
        const hasUserId = userInfo.user_id || userInfo.open_id
        // 对于首页，只需要检查user_id是否存在
        // 权限状态(isAdmin, isDriver)在UserContext中单独检查
        return hasUserId !== ''
    }

    // 监听路由变化，当进入首页时自动刷新
    useEffect(() => {
        // 只有当路由是首页且还未刷新过时
        if (location.pathname === '/' && !hasRefreshed) {
            console.log('进入首页，自动刷新用户信息...')
            setHasRefreshed(true)
            
            // 延迟刷新，确保页面已完全加载
            const timer = setTimeout(() => {
                refreshUserInfo()
            }, 500)
            
            return () => clearTimeout(timer)
        }
    }, [location.pathname, hasRefreshed, refreshUserInfo])

    // 在首页刷新时，如果用户信息有缺失则重新获取
    useEffect(() => {
        // 只有在加载完成后、用户信息不完整且还未刷新过时才重新获取
        if (!loading && !isUserInfoComplete() && hasRefreshed) {
            console.log('用户信息不完整，重新获取...')
            refreshUserInfo()
        }
    }, [loading, userInfo, refreshUserInfo, hasRefreshed])

    const handleReserveCar = () => {
        // navigate('/vehicle-select')
        showToast(CLOSED_TIP, 'warning')
    }

    const handleMyReservations = () => {
        navigate('/my-reservations')
    }

    const handleApproval = () => {
        navigate('/car-approval')
    }

    const handleReturnApproval = () => {
        navigate('/car-return-approval')
    }

    const handleCarReport = () => {
        navigate('/car-report')
    }

    const handleDelayApproval = () => {
        navigate('/delay-approval')
    }

    const handleDispatchCar = () => {
        // navigate('/dispatch')
        showToast(CLOSED_TIP, 'warning')
    }

    return (
        <div className="home">
            <UserInfo userInfo={userInfo} />
            <div className="reserve-container">
                <div className="reserve-card" onClick={handleReserveCar}>
                    <h3>预约用车</h3>
                </div>
                <div className="reserve-card" onClick={handleMyReservations}>
                    <h3>预约记录</h3>
                </div>
                {isAdmin && (
                    <>
                        <div className="reserve-card" onClick={handleDispatchCar}>
                            <h3>直接派车</h3>
                        </div>
                        <div className="reserve-card" onClick={handleApproval}>
                            <h3>用车审批</h3>
                        </div>
                        <div className="reserve-card" onClick={handleDelayApproval}>
                            <h3>延期审批</h3>
                        </div>
                    </>
                )}
                
                {/* 还车审批和用车报表对管理员和司机开放 */}
                {(isAdmin || isDriver) && (
                    <>
                        <div className="reserve-card" onClick={handleReturnApproval}>
                            <h3>还车审批</h3>
                        </div>
                        <div className="reserve-card" onClick={handleCarReport}>
                            <h3>用车报表</h3>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}